<template>
  <cms-ugc-curalate :content />
</template>

<script lang="ts" setup>
import type { UGCContent } from '#types/components/cms/ugc'

defineProps<{ content: UGCContent }>()
</script>
